module.exports = __webpack_public_path__ + "img/9-5.34562801.jpg";